export const PASSWORD_RESET_REQUEST_SUCCESS_MESSAGE =
  'Якщо акаунт із таким email існує, код надіслано на пошту.';

const GUARANTEED_DELIVERY_PATTERNS = [
  'код успішно надіслано',
  'успішно надіслано на вашу пошту',
];

export function messageImpliesGuaranteedDelivery(message) {
  const normalized = String(message || '').trim().toLowerCase();
  return GUARANTEED_DELIVERY_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function getPasswordResetRequestFeedback({ sendMailError, sendMailSuccess, email }) {
  if (sendMailError) {
    return { kind: 'error', message: sendMailError };
  }

  if (sendMailSuccess) {
    return {
      kind: 'success',
      message: PASSWORD_RESET_REQUEST_SUCCESS_MESSAGE,
      advanceToStep: 2,
      startResendCooldown: true,
      email: email || '',
    };
  }

  return null;
}

export function getPasswordResetRequestSuccessMessageForEmail(email) {
  const feedback = getPasswordResetRequestFeedback({
    sendMailSuccess: true,
    email,
  });
  return feedback ? feedback.message : null;
}
